import { ArrowUpRight, Star } from "lucide-react";

const GOOGLE_REVIEWS_URL = "https://www.google.com/search?q=DMZ+Normandie+ma%C3%A7onnerie+Bernay+avis";

const REVIEW_BY_SERVICE = {
  "renovation-bernay": { name: "Sandrine L.", since: "Il y a 15 semaines" },
  rejointoiement: { name: "Sandrine L.", since: "Il y a 15 semaines" },
  "parement-brique": { name: "Figen Y.", since: "Il y a 17 semaines" },
  "gros-oeuvre": { name: "Vincent B.", since: "Il y a 4 semaines" },
  fondations: { name: "Vincent B.", since: "Il y a 4 semaines" },
  "construction-murs": { name: "Kevin J.", since: "Il y a 17 semaines" },
  "dalles-beton": { name: "Joao D.", since: "Il y a 17 semaines" },
  "beton-amenagements-exterieurs": { name: "Joao D.", since: "Il y a 17 semaines" },
  "extension-maison": { name: "Julia L.", since: "Il y a 17 semaines" },
};

export default function ChantierReview({ service }) {
  const review = REVIEW_BY_SERVICE[service] || { name: "Vincent B.", since: "Il y a 4 semaines" };

  return (
    <div className="mt-8 border border-[#C4A484]/25 bg-[#C4A484]/5 p-6" data-testid="chantier-google-review">
      <div className="flex items-center justify-between gap-4 mb-4">
        <div>
          <p className="text-[10px] tracking-[0.35em] uppercase text-[#C4A484] mb-2">Avis Google vérifié</p>
          <p className="font-medium text-[#F5F5F0]">{review.name}</p>
          <p className="text-xs text-zinc-600 mt-1">{review.since}</p>
        </div>
        <span className="w-11 h-11 rounded-full bg-[#C4A484] text-[#0A0A0A] flex items-center justify-center font-semibold text-lg shrink-0">
          {review.name[0]}
        </span>
      </div>
      <div className="flex gap-1 mb-4" aria-label="Note Google 5 sur 5">
        {[...Array(5)].map((_, i) => (
          <Star key={i} size={15} className="text-[#C4A484] fill-[#C4A484]" />
        ))}
      </div>
      <p className="text-sm font-light text-zinc-400 leading-relaxed">
        DMZ Normandie est notée 5,0/5 sur 12 avis Google. Consultez les avis publics pour lire les retours clients.
      </p>
      <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 mt-5 text-xs tracking-[0.25em] uppercase text-[#C4A484] hover:text-[#F5F5F0] transition-colors" data-testid="chantier-google-link">
        Voir les avis Google <ArrowUpRight size={13} />
      </a>
    </div>
  );
}
